import * as React from 'react';

const IconSuccess = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M32 54.75C44.5645 54.75 54.75 44.5645 54.75 32C54.75 19.4355 44.5645 9.25 32 9.25C19.4355 9.25 9.25 19.4355 9.25 32C9.25 44.5645 19.4355 54.75 32 54.75ZM32 58C46.3594 58 58 46.3594 58 32C58 17.6406 46.3594 6 32 6C17.6406 6 6 17.6406 6 32C6 46.3594 17.6406 58 32 58Z" fill="#598F45"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2231 24.4034L29.9126 43.0439L20.0177 33.149L22.3158 30.8509L29.7543 38.2894L43.7772 22.2632L46.2231 24.4034Z" fill="#598F45"/>
</svg>
);

export default IconSuccess;
